import * as Constants from '../constants/reward';

const initialState = {
  activeReward: null,
  rewards: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_REWARDS_SUCCESS:
      return {
        ...state,
        rewards: action.payload,
      };
    case Constants.GET_REWARD_SUCCESS:
      return {
        ...state,
        activeReward: action.payload,
      };
    case Constants.CLEAR_REWARD:
      return {
        ...state,
        activeReward: null,
      };
    default:
      return state;
  }
};
